$(document).ready(function() {
    var cupSizes = [
    "AA","A","B","C","D","DD/E","DDD/F","G","H","I","J","K",
    "L","M","N","O","P","Q","R","S","T","U"
    ];

    var overrideMap = {
        /* AA */
        "26AA": "AA",
        "28AA": "AA",
        "30AA": "AA",
        "32AA": "AA",
        "34AA": "AA",
        "36AA": "A",
        "38AA": "B",
        "40AA": "C",
        "42AA": "D",
        "44AA": "E",

        /* A */
        "26A": "AA",
        "28A": "AA",
        "30A": "AA",
        "32A": "AA",
        "34A": "A",
        "36A": "B",
        "38A": "C",
        "40A": "D",
        "42A": "E",
        "44A": "F",

        /* B */
        "26B": "AA",
        "28B": "AA",
        "30B": "AA",
        "32B": "A",
        "34B": "B",
        "36B": "C",
        "38B": "D",
        "40B": "E",
        "42B": "F",
        "44B": "G",

        /* C */
        "26C": "AA",
        "28C": "AA",
        "30C": "A",
        "32C": "B",
        "34C": "C",
        "36C": "D",
        "38C": "E",
        "40C": "F",
        "42C": "G",
        "44C": "H",

        /* D */
        "26D": "AA",
        "28D": "A",
        "30D": "B",
        "32D": "C",
        "34D": "D",
        "36D": "E",
        "38D": "F",
        "40D": "G",
        "42D": "H",
        "44D": "I",

        /* DD/E */
        "26DD/E": "A",
        "28DD/E": "B",
        "30DD/E": "C",
        "32DD/E": "D",
        "34DD/E": "E",
        "36DD/E": "F",
        "38DD/E": "G",
        "40DD/E": "H",
        "42DD/E": "I",
        "44DD/E": "J",

        /* DDD/F */
        "26DDD/F": "B",
        "28DDD/F": "C",
        "30DDD/F": "D",
        "32DDD/F": "E",
        "34DDD/F": "F",
        "36DDD/F": "G",
        "38DDD/F": "H",
        "40DDD/F": "I",
        "42DDD/F": "J",
        "44DDD/F": "K",

        /* G */
        "26G": "C",
        "28G": "D",
        "30G": "E",
        "32G": "F",
        "34G": "G",
        "36G": "H",
        "38G": "I",
        "40G": "J",
        "42G": "K",
        "44G": "L",

        /* H */
        "26H": "D",
        "28H": "E",
        "30H": "F",
        "32H": "G",
        "34H": "H",
        "36H": "I",
        "38H": "J",
        "40H": "K",
        "42H": "L",
        "44H": "M",

        /* I */
        "26I": "E",
        "28I": "F",
        "30I": "G",
        "32I": "H",
        "34I": "I",
        "36I": "J",
        "38I": "K",
        "40I": "L",
        "42I": "M",
        "44I": "N",

        /* J */
        "26J": "F",
        "28J": "G",
        "30J": "H",
        "32J": "I",
        "34J": "J",
        "36J": "K",
        "38J": "L",
        "40J": "M",
        "42J": "N",
        "44J": "O",

        /* K */
        "26K": "G",
        "28K": "H",
        "30K": "I",
        "32K": "J",
        "34K": "K",
        "36K": "L",
        "38K": "M",
        "40K": "N",
        "42K": "O",
        "44K": "P",

        /* L */
        "26L": "H",
        "28L": "I",
        "30L": "J",
        "32L": "K",
        "34L": "L",
        "36L": "M",
        "38L": "N",
        "40L": "O",
        "42L": "P",
        "44L": "Q",

        /* M */
        "26M": "I",
        "28M": "J",
        "30M": "K",
        "32M": "L",
        "34M": "M",
        "36M": "N",
        "38M": "O",
        "40M": "P",
        "42M": "Q",
        "44M": "R",

        /* N */
        "26N": "J",
        "28N": "K",
        "30N": "L",
        "32N": "M",
        "34N": "N",
        "36N": "O",
        "38N": "P",
        "40N": "Q",
        "42N": "R",

        /* O */
        "26O": "K",
        "28O": "L",
        "30O": "M",
        "32O": "N",
        "34O": "O",
        "36O": "P",
        "38O": "Q",
        "40O": "R",

        /* P */
        "26P": "L",
        "28P": "M",
        "30P": "N",
        "32P": "O",
        "34P": "P",
        "36P": "Q",
        "38P": "R",

        /* Q */
        "26Q": "M",
        "28Q": "N",
        "30Q": "O",
        "32Q": "P",
        "34Q": "Q",
        "36Q": "R",

        /* R */
        "26R": "N",
        "28R": "O",
        "30R": "P",
        "32R": "Q",
        "34R": "R",

        /* S */
        "26S": "O",
        "28S": "P",
        "30S": "Q",
        "32S": "R",

        /* T */
        "26T": "P",
        "28T": "Q",
        "30T": "R",

        /* U */
        "26U": "Q",
        "28U": "R",
    };

    var conversionTable = {
        /* AA CUP */
        "26AA": { au: "4AA",  uk: "26AA", eu: "55AA",  es: "70AA",  it: "00AA", boomba: "AA" },
        "28AA": { au: "6AA",  uk: "28AA", eu: "60AA",  es: "75AA",  it: "00AA", boomba: "AA" },
        "30AA": { au: "8AA",  uk: "30AA", eu: "65AA",  es: "80AA",  it: "0AA",  boomba: "AA" },
        "32AA": { au: "10AA", uk: "32AA", eu: "70AA",  es: "85AA",  it: "1AA",  boomba: "AA" },
        "34AA": { au: "12AA", uk: "34AA", eu: "75AA",  es: "90AA",  it: "2AA",  boomba: "AA" },
        "36AA": { au: "14AA", uk: "36AA", eu: "80AA",  es: "95AA",  it: "3AA",  boomba: "A"  },
        "38AA": { au: "16AA", uk: "38AA", eu: "85AA",  es: "100AA", it: "4AA", boomba: "B"  },
        "40AA": { au: "18AA", uk: "40AA", eu: "90AA",  es: "105AA", it: "5AA", boomba: "C"  },
        "42AA": { au: "20AA", uk: "42AA", eu: "95AA",  es: "110AA", it: "6AA", boomba: "D"  },
        "44AA": { au: "22AA", uk: "44AA", eu: "100AA", es: "115AA", it: "7AA", boomba: "E"  },

        /* A CUP */
        "26A": { au: "4A", uk: "26A", eu: "55A", es: "70A", it: "00A", boomba: "AA" },
        "28A": { au: "6A",  uk: "28A", eu: "60A",  es: "75A",  it: "00A", boomba: "AA" },
        "30A": { au: "8A",  uk: "30A", eu: "65A",  es: "80A",  it: "0A",  boomba: "AA" },
        "32A": { au: "10A", uk: "32A", eu: "70A",  es: "85A",  it: "1A",  boomba: "AA" },
        "34A": { au: "12A", uk: "34A", eu: "75A",  es: "90A",  it: "2A",  boomba: "A"  },
        "36A": { au: "14A", uk: "36A", eu: "80A",  es: "95A",  it: "3A",  boomba: "B"  },
        "38A": { au: "16A", uk: "38A", eu: "85A",  es: "100A", it: "4A",  boomba: "C"  },
        "40A": { au: "18A", uk: "40A", eu: "90A",  es: "105A", it: "5A",  boomba: "D"  },
        "42A": { au: "20A", uk: "42A", eu: "95A",  es: "110A", it: "6A",  boomba: "E"  },
        "44A": { au: "22A", uk: "44A", eu: "100A", es: "115A", it: "7A",  boomba: "F"  },

        /* B CUP */
        "26B": { au: "4B", uk: "26B", eu: "55B", es: "70B", it: "00B", boomba: "AA" },
        "28B": { au: "6B",  uk: "28B", eu: "60B",  es: "75B",  it: "00B", boomba: "AA" },
        "30B": { au: "8B",  uk: "30B", eu: "65B",  es: "80B",  it: "0B",  boomba: "AA" },
        "32B": { au: "10B", uk: "32B", eu: "70B",  es: "85B",  it: "1B",  boomba: "A"  },
        "34B": { au: "12B", uk: "34B", eu: "75B",  es: "90B",  it: "2B",  boomba: "B"  },
        "36B": { au: "14B", uk: "36B", eu: "80B",  es: "95B",  it: "3B",  boomba: "C"  },
        "38B": { au: "16B", uk: "38B", eu: "85B",  es: "100B", it: "4B",  boomba: "D"  },
        "40B": { au: "18B", uk: "40B", eu: "90B",  es: "105B", it: "5B",  boomba: "E"  },
        "42B": { au: "20B", uk: "42B", eu: "95B",  es: "110B", it: "6B",  boomba: "F"  },
        "44B": { au: "22B", uk: "44B", eu: "100B", es: "115B", it: "7B",  boomba: "G"  },

        /* B CUP */
        "26C": { au: "4C", uk: "26C", eu: "55C", es: "70C", it: "00C", boomba: "AA" },
        "28C": { au: "6C",  uk: "28C", eu: "60C",  es: "75C",  it: "00C", boomba: "AA" },
        "30C": { au: "8C",  uk: "30C", eu: "65C",  es: "80C",  it: "0C",  boomba: "A"  },
        "32C": { au: "10C", uk: "32C", eu: "70C",  es: "85C",  it: "1C",  boomba: "B"  },
        "34C": { au: "12C", uk: "34C", eu: "75C",  es: "90C",  it: "2C",  boomba: "C"  },
        "36C": { au: "14C", uk: "36C", eu: "80C",  es: "95C",  it: "3C",  boomba: "D"  },
        "38C": { au: "16C", uk: "38C", eu: "85C",  es: "100C", it: "4C",  boomba: "E"  },
        "40C": { au: "18C", uk: "40C", eu: "90C",  es: "105C", it: "5C",  boomba: "F"  },
        "42C": { au: "20C", uk: "42C", eu: "95C",  es: "110C", it: "6C",  boomba: "G"  },
        "44C": { au: "22C", uk: "44C", eu: "100C", es: "115C", it: "7C",  boomba: "H"  },

        /* D CUP */
        "26D": { au: "4D", uk: "26D", eu: "55D", es: "70D", it: "00D", boomba: "AA" },
        "28D": { au: "6D",  uk: "28D", eu: "60D",  es: "75D",  it: "00D", boomba: "A"  },
        "30D": { au: "8D",  uk: "30D", eu: "65D",  es: "80D",  it: "0D",  boomba: "B"  },
        "32D": { au: "10D", uk: "32D", eu: "70D",  es: "85D",  it: "1D",  boomba: "C"  },
        "34D": { au: "12D", uk: "34D", eu: "75D",  es: "90D",  it: "2D",  boomba: "D"  },
        "36D": { au: "14D", uk: "36D", eu: "80D",  es: "95D",  it: "3D",  boomba: "E"  },
        "38D": { au: "16D", uk: "38D", eu: "85D",  es: "100D", it: "4D",  boomba: "F"  },
        "40D": { au: "18D", uk: "40D", eu: "90D",  es: "105D", it: "5D",  boomba: "G"  },
        "42D": { au: "20D", uk: "42D", eu: "95D",  es: "110D", it: "6D",  boomba: "H"  },
        "44D": { au: "22D", uk: "44D", eu: "100D", es: "115D", it: "7D",  boomba: "I"  },

        /* DD/E CUP */
        "26DD/E": { au: "4E", uk: "26DD", eu: "55E", es: "70E", it: "00DD", boomba: "A" },
        "28DD/E": { au: "6E",  uk: "28DD", eu: "60E",  es: "75E",  it: "00DD", boomba: "B"  },
        "30DD/E": { au: "8E",  uk: "30DD", eu: "65E",  es: "80E",  it: "0DD",  boomba: "C"  },
        "32DD/E": { au: "10E", uk: "32DD", eu: "70E",  es: "85E",  it: "1DD",  boomba: "D"  },
        "34DD/E": { au: "12E", uk: "34DD", eu: "75E",  es: "90E",  it: "2DD",  boomba: "E"  },
        "36DD/E": { au: "14E", uk: "36DD", eu: "80E",  es: "95E",  it: "3DD",  boomba: "F"  },
        "38DD/E": { au: "16E", uk: "38DD", eu: "85E",  es: "100E", it: "4DD",  boomba: "G"  },
        "40DD/E": { au: "18E", uk: "40DD", eu: "90E",  es: "105E", it: "5DD",  boomba: "H"  },
        "42DD/E": { au: "20E", uk: "42DD", eu: "95E",  es: "110E", it: "6DD",  boomba: "I"  },
        "44DD/E": { au: "22E", uk: "44DD", eu: "100E", es: "115E", it: "7DD",  boomba: "J"  },

        /* DDD/F CUP */
        "26DDD/F": { au: "4F", uk: "26E", eu: "55F", es: "70F", it: "00E", boomba: "B" },
        "28DDD/F": { au: "6F",  uk: "28E", eu: "60F",  es: "75F",  it: "00E", boomba: "C"  },
        "30DDD/F": { au: "8F",  uk: "30E", eu: "65F",  es: "80F",  it: "0E",  boomba: "D"  },
        "32DDD/F": { au: "10F", uk: "32E", eu: "70F",  es: "85F",  it: "1E",  boomba: "E"  },
        "34DDD/F": { au: "12F", uk: "34E", eu: "75F",  es: "90F",  it: "2E",  boomba: "F"  },
        "36DDD/F": { au: "14F", uk: "36E", eu: "80F",  es: "95F",  it: "3E",  boomba: "G"  },
        "38DDD/F": { au: "16F", uk: "38E", eu: "85F",  es: "100F", it: "4E",  boomba: "H"  },
        "40DDD/F": { au: "18F", uk: "40E", eu: "90F",  es: "105F", it: "5E",  boomba: "I"  },
        "42DDD/F": { au: "20F", uk: "42E", eu: "95F",  es: "110F", it: "6E",  boomba: "J"  },
        "44DDD/F": { au: "22F", uk: "44E", eu: "100F", es: "115F", it: "7E",  boomba: "K"  },

        /* G CUP */
        "26G": { au: "4G", uk: "26F", eu: "55G", es: "70G", it: "00F", boomba: "C" },
        "28G": { au: "6G",  uk: "28F", eu: "60G",  es: "75G",  it: "00F", boomba: "D"  },
        "30G": { au: "8G",  uk: "30F", eu: "65G",  es: "80G",  it: "0F",  boomba: "E"  },
        "32G": { au: "10G", uk: "32F", eu: "70G",  es: "85G",  it: "1F",  boomba: "F"  },
        "34G": { au: "12G", uk: "34F", eu: "75G",  es: "90G",  it: "2F",  boomba: "G"  },
        "36G": { au: "14G", uk: "36F", eu: "80G",  es: "95G",  it: "3F",  boomba: "H"  },
        "38G": { au: "16G", uk: "38F", eu: "85G",  es: "100G", it: "4F",  boomba: "I"  },
        "40G": { au: "18G", uk: "40F", eu: "90G",  es: "105G", it: "5F",  boomba: "J"  },
        "42G": { au: "20G", uk: "42F", eu: "95G",  es: "110G", it: "6F",  boomba: "K"  },
        "44G": { au: "22G", uk: "44F", eu: "100G", es: "115G", it: "7F",  boomba: "L"  },

        /* H CUP */
        "26H": { au: "4H", uk: "26FF", eu: "55H", es: "70H", it: "00FF", boomba: "D" },
        "28H": { au: "6H",  uk: "28FF", eu: "60H",  es: "75H",  it: "00FF", boomba: "E"  },
        "30H": { au: "8H",  uk: "30FF", eu: "65H",  es: "80H",  it: "0FF",  boomba: "F"  },
        "32H": { au: "10H", uk: "32FF", eu: "70H",  es: "85H",  it: "1FF",  boomba: "G"  },
        "34H": { au: "12H", uk: "34FF", eu: "75H",  es: "90H",  it: "2FF",  boomba: "H"  },
        "36H": { au: "14H", uk: "36FF", eu: "80H",  es: "95H",  it: "3FF",  boomba: "I"  },
        "38H": { au: "16H", uk: "38FF", eu: "85H",  es: "100H", it: "4FF",  boomba: "J"  },
        "40H": { au: "18H", uk: "40FF", eu: "90H",  es: "105H", it: "5FF",  boomba: "K"  },
        "42H": { au: "20H", uk: "42FF", eu: "95H",  es: "110H", it: "6FF",  boomba: "L"  },
        "44H": { au: "22H", uk: "44FF", eu: "100H", es: "115H", it: "7FF",  boomba: "M"  },

        /* I CUP */
        "26I": { au: "4I", uk: "26G",  eu: "55J", es: "70J", it: "00G",  boomba: "E" },
        "28I": { au: "6I",  uk: "28G", eu: "60J",  es: "75J",  it: "00G", boomba: "F"  },
        "30I": { au: "8I",  uk: "30G", eu: "65J",  es: "80J",  it: "0G",  boomba: "G"  },
        "32I": { au: "10I", uk: "32G", eu: "70J",  es: "85J",  it: "1G",  boomba: "H"  },
        "34I": { au: "12I", uk: "34G", eu: "75J",  es: "90J",  it: "2G",  boomba: "I"  },
        "36I": { au: "14I", uk: "36G", eu: "80J",  es: "95J",  it: "3G",  boomba: "J"  },
        "38I": { au: "16I", uk: "38G", eu: "85J",  es: "100J", it: "4G",  boomba: "K"  },
        "40I": { au: "18I", uk: "40G", eu: "90J",  es: "105J", it: "5G",  boomba: "L"  },
        "42I": { au: "20I", uk: "42G", eu: "95J",  es: "110J", it: "6G",  boomba: "M"  },
        "44I": { au: "22I", uk: "44G", eu: "100J", es: "115J", it: "7G",  boomba: "N"  },

        /* J CUP */
        "26J": { au: "4J", uk: "26GG", eu: "55K", es: "70K", it: "00GG", boomba: "F" },
        "28J": { au: "6J",  uk: "28GG", eu: "60K",  es: "75K",  it: "00GG", boomba: "G"  },
        "30J": { au: "8J",  uk: "30GG", eu: "65K",  es: "80K",  it: "0GG",  boomba: "H"  },
        "32J": { au: "10J", uk: "32GG", eu: "70K",  es: "85K",  it: "1GG",  boomba: "I"  },
        "34J": { au: "12J", uk: "34GG", eu: "75K",  es: "90K",  it: "2GG",  boomba: "J"  },
        "36J": { au: "14J", uk: "36GG", eu: "80K",  es: "95K",  it: "3GG",  boomba: "K"  },
        "38J": { au: "16J", uk: "38GG", eu: "85K",  es: "100K", it: "4GG",  boomba: "L"  },
        "40J": { au: "18J", uk: "40GG", eu: "90K",  es: "105K", it: "5GG",  boomba: "M"  },
        "42J": { au: "20J", uk: "42GG", eu: "95K",  es: "110K", it: "6GG",  boomba: "N"  },
        "44J": { au: "22J", uk: "44GG", eu: "100K", es: "115K", it: "7GG",  boomba: "O"  },

        /* K CUP */
        "26K": { au: "4K", uk: "26H",  eu: "55L", es: "70L", it: "00H",  boomba: "G" },
        "28K": { au: "6K",  uk: "28H", eu: "60L",  es: "75L",  it: "00H", boomba: "H"  },
        "30K": { au: "8K",  uk: "30H", eu: "65L",  es: "80L",  it: "0H",  boomba: "I"  },
        "32K": { au: "10K", uk: "32H", eu: "70L",  es: "85L",  it: "1H",  boomba: "J"  },
        "34K": { au: "12K", uk: "34H", eu: "75L",  es: "90L",  it: "2H",  boomba: "K"  },
        "36K": { au: "14K", uk: "36H", eu: "80L",  es: "95L",  it: "3H",  boomba: "L"  },
        "38K": { au: "16K", uk: "38H", eu: "85L",  es: "100L", it: "4H",  boomba: "M"  },
        "40K": { au: "18K", uk: "40H", eu: "90L",  es: "105L", it: "5H",  boomba: "N"  },
        "42K": { au: "20K", uk: "42H", eu: "95L",  es: "110L", it: "6H",  boomba: "O"  },
        "44K": { au: "22K", uk: "44H", eu: "100L", es: "115L", it: "7H",  boomba: "P"  },

        /* L CUP */
        "26L": { au: "4L", uk: "26HH", eu: "55M", es: "70M", it: "00HH", boomba: "H" },
        "28L": { au: "6L",  uk: "28HH", eu: "60M",  es: "75M",  it: "00HH", boomba: "I"  },
        "30L": { au: "8L",  uk: "30HH", eu: "65M",  es: "80M",  it: "0HH",  boomba: "J"  },
        "32L": { au: "10L", uk: "32HH", eu: "70M",  es: "85M",  it: "1HH",  boomba: "K"  },
        "34L": { au: "12L", uk: "34HH", eu: "75M",  es: "90M",  it: "2HH",  boomba: "L"  },
        "36L": { au: "14L", uk: "36HH", eu: "80M",  es: "95M",  it: "3HH",  boomba: "M"  },
        "38L": { au: "16L", uk: "38HH", eu: "85M",  es: "100M", it: "4HH",  boomba: "N"  },
        "40L": { au: "18L", uk: "40HH", eu: "90M",  es: "105M", it: "5HH",  boomba: "O"  },
        "42L": { au: "20L", uk: "42HH", eu: "95M",  es: "110M", it: "6HH",  boomba: "P"  },
        "44L": { au: "22L", uk: "44HH", eu: "100M", es: "115M", it: "7HH",  boomba: "Q"  },

        /* M CUP */
        "26M": { au: "4M", uk: "26J",  eu: "55N", es: "70N", it: "00J",  boomba: "I" },
        "28M": { au: "6M",  uk: "28J", eu: "60N",  es: "75N",  it: "00J", boomba: "J"  },
        "30M": { au: "8M",  uk: "30J", eu: "65N",  es: "80N",  it: "0J",  boomba: "K"  },
        "32M": { au: "10M", uk: "32J", eu: "70N",  es: "85N",  it: "1J",  boomba: "L"  },
        "34M": { au: "12M", uk: "34J", eu: "75N",  es: "90N",  it: "2J",  boomba: "M"  },
        "36M": { au: "14M", uk: "36J", eu: "80N",  es: "95N",  it: "3J",  boomba: "N"  },
        "38M": { au: "16M", uk: "38J", eu: "85N",  es: "100N", it: "4J",  boomba: "O"  },
        "40M": { au: "18M", uk: "40J", eu: "90N",  es: "105N", it: "5J",  boomba: "P"  },
        "42M": { au: "20M", uk: "42J", eu: "95N",  es: "110N", it: "6J",  boomba: "Q"  },
        "44M": { au: "22M", uk: "44J", eu: "100N", es: "115N", it: "7J",  boomba: "R"  },

        /* N CUP */
        "26N": { au: "4N", uk: "26JJ", eu: "55O", es: "70O", it: "0JJ",  boomba: "J" },
        "28N": { au: "6N",  uk: "28JJ", eu: "60O",  es: "75O",  it: "00JJ", boomba: "K"  },
        "30N": { au: "8N",  uk: "30JJ", eu: "65O",  es: "80O",  it: "0JJ",  boomba: "L"  },
        "32N": { au: "10N", uk: "32JJ", eu: "70O",  es: "85O",  it: "1JJ",  boomba: "M"  },
        "34N": { au: "12N", uk: "34JJ", eu: "75O",  es: "90O",  it: "2JJ",  boomba: "N"  },
        "36N": { au: "14N", uk: "36JJ", eu: "80O",  es: "95O",  it: "3JJ",  boomba: "O"  },
        "38N": { au: "16N", uk: "38JJ", eu: "85O",  es: "100O", it: "4JJ",  boomba: "P"  },
        "40N": { au: "18N", uk: "40JJ", eu: "90O",  es: "105O", it: "5JJ",  boomba: "Q"  },
        "42N": { au: "20N", uk: "42JJ", eu: "95O",  es: "110O", it: "6JJ",  boomba: "R"  },

        /* O CUP */
        "26O": { au: "4O", uk: "26K",  eu: "55P", es: "70P", it: "00K",  boomba: "K" },
        "28O": { au: "6O",  uk: "28K", eu: "60P",  es: "75P",  it: "00K", boomba: "L"  },
        "30O": { au: "8O",  uk: "30K", eu: "65P",  es: "80P",  it: "0K",  boomba: "M"  },
        "32O": { au: "10O", uk: "32K", eu: "70P",  es: "85P",  it: "1K",  boomba: "N"  },
        "34O": { au: "12O", uk: "34K", eu: "75P",  es: "90P",  it: "2K",  boomba: "O"  },
        "36O": { au: "14O", uk: "36K", eu: "80P",  es: "95P",  it: "3K",  boomba: "P"  },
        "38O": { au: "16O", uk: "38K", eu: "85P",  es: "100P", it: "4K",  boomba: "Q"  },
        "40O": { au: "18O", uk: "40K", eu: "90P",  es: "105P", it: "5K",  boomba: "R"  },

        /* P CUP */
        "26P": { au: "4P", uk: "26KK", eu: "55R", es: "70R", it: "00KK", boomba: "L" },
        "28P": { au: "6P",  uk: "28KK", eu: "60R",  es: "75R",  it: "00KK", boomba: "M"  },
        "30P": { au: "8P",  uk: "30KK", eu: "65R",  es: "80R",  it: "0KK",  boomba: "N"  },
        "32P": { au: "10P", uk: "32KK", eu: "70R",  es: "85R",  it: "1KK",  boomba: "O"  },
        "34P": { au: "12P", uk: "34KK", eu: "75R",  es: "90R",  it: "2KK",  boomba: "P"  },
        "36P": { au: "14P", uk: "36KK", eu: "80R",  es: "95R",  it: "3KK",  boomba: "Q"  },
        "38P": { au: "16P", uk: "38KK", eu: "85R",  es: "100R", it: "4KK",  boomba: "R"  },

        /* Q CUP */
        "28Q": { au: "6R",  uk: "28L", eu: "60S",  es: "75S",  it: "00L", boomba: "N"  },
        "30Q": { au: "8R",  uk: "30L", eu: "65S",  es: "80S",  it: "0L",  boomba: "O"  },
        "32Q": { au: "10R", uk: "32L", eu: "70S",  es: "85S",  it: "1L",  boomba: "P"  },
        "34Q": { au: "12R", uk: "34L", eu: "75S",  es: "90S",  it: "2L",  boomba: "Q"  },
        "36Q": { au: "14R", uk: "36L", eu: "80S",  es: "95S",  it: "3L",  boomba: "R"  },

        /* R CUP */
        "28R": { au: "6S",  uk: "28LL", eu: "60T",  es: "75T",  it: "00LL", boomba: "O"  },
        "30R": { au: "8S",  uk: "30LL", eu: "65T",  es: "80T",  it: "0LL",  boomba: "P"  },
        "32R": { au: "10S", uk: "32LL", eu: "70T",  es: "85T",  it: "1LL",  boomba: "Q"  },
        "34R": { au: "12S", uk: "34LL", eu: "75T",  es: "90T",  it: "2LL",  boomba: "R"  },

        /* S CUP */
        "28S": { au: "6T",  uk: "28M", eu: "60U",  es: "75U",  it: "00M", boomba: "P"  },
        "30S": { au: "8T",  uk: "30M", eu: "65U",  es: "80U",  it: "0M",  boomba: "Q"  },
        "32S": { au: "10T", uk: "32M", eu: "70U",  es: "85U",  it: "1M",  boomba: "R"  },

        /* T CUP */
        "28T": { au: "6U",  uk: "28MM", eu: "60V",  es: "75V",  it: "00MM", boomba: "Q"  },
        "30T": { au: "8U",  uk: "30MM", eu: "65V",  es: "80V",  it: "0M",  boomba: "R"  },

        /* U CUP */
        "28U": { au: "6V",  uk: "28N", eu: "60W",  es: "75W",  it: "00N", boomba: "R"  },
    };

$(document).ready(function () {

  const INCH_TO_CM = 2.54;

  const UNDER_MIN_IN = 26;
  const UNDER_MAX_IN = 44;
  const OVER_MIN_IN  = 26;
  const OVER_MAX_IN  = 65;

  const UNDER_MIN_CM = UNDER_MIN_IN * INCH_TO_CM;
  const UNDER_MAX_CM = UNDER_MAX_IN * INCH_TO_CM;
  const OVER_MIN_CM  = OVER_MIN_IN  * INCH_TO_CM;
  const OVER_MAX_CM  = OVER_MAX_IN  * INCH_TO_CM;

  function cmToIn(cm) {
    return cm / INCH_TO_CM;
  }

  function roundUnderbust(inches) {
    let r = Math.round(inches);
    if (r % 2 !== 0) r += 1;
    return r;
  }

  function roundOverbust(inches) {
    return Math.round(inches);
  }

  function showError(msg) {
    $('#error-msg').html(msg).fadeIn();
  }

  function clearError() {
    $('#error-msg').fadeOut();
    $('#underbust, #overbust').removeClass('border-red');
  }

  $('#convertion').on('change', function () {
    const unit = $(this).val();

    if (unit === 'centimeters') {
      $('#underbust')
        .attr({ min: UNDER_MIN_CM, max: UNDER_MAX_CM, step: 0.1 })
        .attr('placeholder', 'Unterbrustumfang eingeben (cm)');

      $('#overbust')
        .attr({ min: OVER_MIN_CM, max: OVER_MAX_CM, step: 0.1 })
        .attr('placeholder', 'Brustumfang eingeben (cm)');
    } else {
      $('#underbust')
        .attr({ min: UNDER_MIN_IN, max: UNDER_MAX_IN, step: 1 })
        .attr('placeholder', 'Unterbrustumfang eingeben (Zoll)');

      $('#overbust')
        .attr({ min: OVER_MIN_IN, max: OVER_MAX_IN, step: 1 })
        .attr('placeholder', 'Brustumfang eingeben (Zoll)');
    }

    clearError();
  });


  $(document).on('click', '.btn-get-size', function (e) {
  e.preventDefault();

  const unit = $('#convertion').val();

  let underVal = $('#underbust').val();
  let overVal  = $('#overbust').val();

  $('#underbust, #overbust').removeClass('border-red');

  let errors = [];

  let under = Number(underVal);
  let over  = Number(overVal);

  if (underVal === '') {
    errors.push('Unterbrustumfang ist erforderlich.');
    $('#underbust').addClass('border-red');
  }
  else if (isNaN(under)) {
    errors.push('Unterbrustumfang muss eine Zahl sein.');
    $('#underbust').addClass('border-red');
  }
  else if (
    (unit === 'centimeters' && (under < UNDER_MIN_CM || under > UNDER_MAX_CM)) ||
    (unit !== 'centimeters' && (under < UNDER_MIN_IN || under > UNDER_MAX_IN))
  ) {
    errors.push(unit === 'centimeters'
      ? 'Unterbrustumfang muss zwischen 66–112 cm liegen.'
      : 'Unterbrustumfang muss zwischen 26–44 Zoll liegen.'
    );
    $('#underbust').addClass('border-red');
  }

  if (overVal === '') {
    errors.push('Brustumfang ist erforderlich.');
    $('#overbust').addClass('border-red');
  }
  else if (isNaN(over)) {
    errors.push('Brustumfang muss eine Zahl sein.');
    $('#overbust').addClass('border-red');
  }
  else if (
    (unit === 'centimeters' && (over < OVER_MIN_CM || over > OVER_MAX_CM)) ||
    (unit !== 'centimeters' && (over < OVER_MIN_IN || over > OVER_MAX_IN))
  ) {
    errors.push(unit === 'centimeters'
      ? 'Brustumfang muss zwischen 66–165 cm liegen.'
      : 'Brustumfang muss zwischen 26–65 Zoll liegen.'
    );
    $('#overbust').addClass('border-red');
  }

  if (!isNaN(under) && !isNaN(over) && over < under) {
    errors.push('Brustumfang muss gleich oder größer als der Unterbrustumfang sein.');
    $('#overbust').addClass('border-red');
  }

  if (errors.length > 0) {
    showError(errors.join('<br>'));
    return;
  }

  clearError();

  if (unit === 'centimeters') {
    under = cmToIn(under);
    over  = cmToIn(over);
  }

  let calcUnderbust = roundUnderbust(under);
  let calcOverbust  = roundOverbust(over);

  let diff = calcOverbust - calcUnderbust;
  if (diff < 0) diff = 0;
  if (diff > 21) diff = 21;

  let rawCup = cupSizes[diff];
  let finalSizeKey = calcUnderbust + rawCup;

  let conv = conversionTable[finalSizeKey];

  if (!conv) {
    $('.size-result').html('keine Größe');
    $('.size-result-box').addClass('no-size');
    $('.us-result, .au-result, .uk-result, .eu-result, .es-result, .it-result').html('keine Größe');
    $('.product-recommend-slider').hide();
  } else {
    $('.size-result').html(conv.boomba);
    $('.us-result').html(finalSizeKey);
    $('.au-result').html(conv.au);
    $('.uk-result').html(conv.uk);
    $('.eu-result').html(conv.eu);
    $('.es-result').html(conv.es);
    $('.it-result').html(conv.it);
    $('.product-recommend-slider').hide();
    $('.product-recommend-slider.' + conv.boomba).show();
  }

  $('#htm-cal').fadeOut(300, function () {
    $('#htm-res').fadeIn(300);
  });

});

});


$(document).on('click', '.btn-calc-again', function() {
  $('#htm-res').fadeOut(300, function() {
    $('#htm-cal').fadeIn(300);
  });
});
});

function initSplide(selector, options) {
    const sliders = document.querySelectorAll(selector);

    sliders.forEach(slider => {
        new Splide(slider, options).mount();
    });
}

function splider() {

    initSplide('.product-recommend-slider', {
        perPage: 3,
        perMove: 1,
        pagination: false,
        arrows: false,
        autoplay: false,
        breakpoints: {
            767: { 
                perPage: 2 ,
                type   : 'loop',
                arrows: true,
            },
        }
    });
}
document.addEventListener('DOMContentLoaded', splider);